import { AudioDevice } from './audio-device.types';

export function mapInputDevice(device: MediaDeviceInfo): AudioDevice {
  return {
    deviceId: device.deviceId,
    label: device.label || `Microphone ${device.deviceId.slice(0, 8)}`,
    kind: device.kind,
  };
}

export function mapOutputDevice(device: MediaDeviceInfo): AudioDevice {
  return {
    deviceId: device.deviceId,
    label: device.label || `Speaker ${device.deviceId.slice(0, 8)}`,
    kind: device.kind,
  };
}

export function resolvePermissionError(
  error: unknown,
  isInIframe: boolean,
  t: (key: string) => string
): string {
  if (error instanceof DOMException && error.name === 'NotAllowedError') {
    return isInIframe ? t('settings:mic.micDeniedIframe') : t('settings:mic.micDenied');
  }
  if (error instanceof Error && error.message === t('settings:mic.mediaDevicesNotAvailable')) {
    return t('settings:mic.micNotAvailable');
  }
  return t('settings:mic.failedToLoadDevices');
}
